import * as procurementServices from './procurementServices';

export { procurementServices };
